// Content of the fabrication order acceptance protocol — source of truth is the official Annex G
// "Vehicle Inspection Protocol". Section/item codes below are the official ones (Section 3 skips
// 3.2 and 3.11, which are not part of the basic functional checks). These are the standard protocol
// documents and functional tests; they are official English wording (not translated per language),
// matching the epic ("el contenido detallado del formulario es el del prototipo/Annex G adjunto").

// Section 1 — general information (codes 1.1..1.6). `prefill` marks the fields precargados from the
// fabrication order.
export const SECTION_1_FIELDS = [
  { code: '1.1', key: 'vehicleName', label: 'Vehicle name', placeholder: 'e.g., ASCOD LV' },
  { code: '1.2', key: 'model', label: 'Model', placeholder: 'Model' },
  { code: '1.3', key: 'manufacturer', label: 'Manufacturer', placeholder: 'Manufacturer' },
  { code: '1.4', key: 'year', label: 'Year of manufacture', placeholder: 'YYYY' },
  { code: '1.5', key: 'serial', label: 'Identification Serial No.', placeholder: 'Serial number' },
  { code: '1.6', key: 'mileage', label: 'Mileage', placeholder: '' }
]

// Section 2 — required contractual documents (codes 2.1..2.5, official Annex G order).
export const REQUIRED_DOCUMENTS = [
  { code: '2.1', label: 'Commercial invoice' },
  { code: '2.2', label: 'Conformity Certificate' },
  { code: '2.3', label: 'Spare parts catalogue' },
  { code: '2.4', label: 'Maintenance plan (maintenance works and their frequency)' },
  { code: '2.5', label: 'Maintenance and repair manuals' }
]

// Section 3 — basic functional tests (official Annex G codes; 3.2 and 3.11 are not part of the
// basic checks and are intentionally absent).
export const FUNCTIONAL_TESTS = [
  { code: '3.1', label: 'General exterior aspect check' },
  { code: '3.3', label: 'Check of the engine compartment (general inspection, check systems, check any leakages)' },
  { code: '3.4', label: 'Check of the fixing and fastening elements for lifting and/or transportation on roads, railways, sea or by air' },
  { code: '3.5', label: 'Vehicle lightning system functional check' },
  { code: '3.6', label: 'Check access doors and hatches opening/closing system' },
  { code: '3.7', label: 'General interior aspect check' },
  { code: '3.8', label: 'Functional check of the electrical system' },
  { code: '3.9', label: 'Vehicle interior lightning system functional check' },
  { code: '3.10', label: 'Intercom system functional check' },
  { code: '3.12', label: 'Functional check of the armament system (check the existence of all equipments, start the system, move the Turret in elevation and azimuth a.s.o.)' },
  { code: '3.13', label: 'Functional check of the ventilation and AC system (check the existence of all equipments, start the system, check the functioning)' },
  { code: '3.14', label: 'General functional dynamic check - min. 2 km (functional check for braking, direction, suspension systems, check light witnesses)' }
]

// A fresh, empty checklist row (Passed / Failed / Remarks) for each document or test.
export const emptyChecklist = (items) => items.map(() => ({ passed: false, failed: false, remarks: '' }))

// Section 4 — acceptance committee (Rank / Name / Structure / Date per member, each with their own
// handwritten signature line on the printed PDF). Replaces the former free-text authority/contractor
// {name, role, date} signature blocks.
export const emptyCommitteePerson = () => ({ rank: '', name: '', structure: '', date: '' })

export const emptyCommittee = () => ({
  authorityLeader: emptyCommitteePerson(),
  members: [],
  contractorRepresentative: emptyCommitteePerson()
})

// Tolerates drafts saved before the committee shape existed (missing/partial committee/members).
export const normalizeCommittee = (committee) => {
  const safe = committee || {}
  const members = Array.isArray(safe.members) ? safe.members : []
  return {
    authorityLeader: { ...emptyCommitteePerson(), ...(safe.authorityLeader || {}) },
    members: members.map((member) => ({ ...emptyCommitteePerson(), ...member })),
    contractorRepresentative: { ...emptyCommitteePerson(), ...(safe.contractorRepresentative || {}) }
  }
}
